import BenefitPlan from "../../../app/domain/BenefitPlan";
import restoreBenefitBag from "../restoreBenefitBag";

export default function adaptBenefitPlans({
  benefitPlans,
}: {
  benefitPlans: any[];
}) {
  const keys = ({
    id,
    name,
    benefitBagConfig,
  }: {
    id: string;
    name: string;
    benefitBagConfig: any;
  }) => {
    const activeBagData = benefitBagConfig.find(
      ({ state }) => state === "active"
    );
    return {
      id,
      name,
      benefitBag: activeBagData
        ? restoreBenefitBag({
            benefitBagConfig: activeBagData,
          })
        : undefined,
    };
  };

  return benefitPlans.map((benefitPlan) => new BenefitPlan(keys(benefitPlan)));
}
